<template>
  <default-step-container v-on="containerListeners">
    <template #question>{{ question }}</template>
    <template #default>
      <div class="row">
        <div class="col-12 col-md-2">
          <component
              :is="getComponent(inputs.salutation.type)"
              v-bind="inputs.salutation"
              v-model="form.salutation"
              :invalid="form.errors.salutation"
              class="wizard-step-input"
          ></component>
        </div>
        <div class="col-12 col-md-5">
          <component
              :is="getComponent(inputs.first_name.type)"
              v-bind="inputs.first_name"
              v-model="form.first_name"
              :invalid="form.errors.first_name"
              class="wizard-step-input"
          ></component>
        </div>
        <div class="col-12 col-md-5">
          <component
              :is="getComponent(inputs.last_name.type)"
              v-bind="inputs.last_name"
              v-model="form.last_name"
              :invalid="form.errors.last_name"
              class="wizard-step-input"
          ></component>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <component
              :is="getComponent(inputs.street.type)"
              v-bind="inputs.street"
              v-model="form.street"
              :invalid="form.errors.street"
              class="wizard-step-input"
          ></component>
        </div>
        <div class="col-12 col-md-6">
          <component
              :is="getComponent(inputs.house_number.type)"
              v-bind="inputs.house_number"
              v-model="form.house_number"
              :invalid="form.errors.house_number"
              class="wizard-step-input"
          ></component>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <component
              :is="getComponent(inputs.postal.type)"
              v-bind="inputs.postal"
              v-model="form.postal"
              :invalid="form.errors.postal"
              class="wizard-step-input"
          ></component>
        </div>
        <div class="col-12 col-md-6">
          <component
              :is="getComponent(inputs.city.type)"
              v-bind="inputs.city"
              v-model="form.city"
              :invalid="form.errors.city"
              class="wizard-step-input"
          ></component>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-4">
          <component
              :is="getComponent(inputs.telephone_number.type)"
              v-bind="inputs.telephone_number"
              v-model="form.telephone_number"
              :invalid="form.errors.telephone_number"
              class="wizard-step-input"
          ></component>
        </div>
        <div class="col-12 col-md-4">
          <component
              :is="getComponent(inputs.email.type)"
              v-bind="inputs.email"
              v-model="form.email"
              :invalid="form.errors.email"
              class="wizard-step-input"
          ></component>
        </div>
        <div class="col-12 col-md-4">
          <component
              :is="getComponent(inputs.email_confirmation.type)"
              v-bind="inputs.email_confirmation"
              v-model="form.email_confirmation"
              :invalid="form.errors.email_confirmation"
              class="wizard-step-input"
          ></component>
        </div>
      </div>

      <p>*verpflichtende Angaben</p>
    </template>
  </default-step-container>
</template>
<script>
import DefaultStep from './DefaultStep'

export default {
  extends: DefaultStep
}
</script>
